import { Message, MessageBox } from "element-ui";
import { Base64 } from "js-base64";
import { keepDecimal, division } from "./calc";
import store from "@/store";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

window.Base64 = Base64;

export const time = moment;

export const getWordByNum = number => {
  /**
   * 根据数字获取相应的汉字数字 0 - 10
   * @param {Number} number
   **/
  const words = [
    "零",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十"
  ];
  const num = Number(number);
  if (typeof num !== "number") {
    return;
  }
  if (isNaN(num)) {
    return;
  }
  return words[num];
};

export const generateRandomNum = (len = 6) => {
  /**
   * 生成指定长度的随机数
   * @param {Number} len 长度
   **/
  const generator = () => Math.floor(Math.random() * `1${"0".repeat(len)}`);
  let num = generator();
  while (String(num).length !== len) {
    num = generator();
  }
  return num;
};

export const getRawType = val => {
  /**
   * 获取对象数据类型
   * @param {any} val
   * @return {String} array string ...
   * */
  let toString = Object.prototype.toString;
  return toString
    .call(val)
    .slice(8, -1)
    .toLowerCase();
};

export const isJson = obj => {
  /**
   *判断对象是否为JSON Object
   *@param {Object} obj 需要判断的对象
   **/
  return getRawType(obj) === "object";
};

export const compressImg = file => {
  /**
   *压缩图片文件 不支持透明
   *@param {File} file File文件
   **/
  function convertBase64UrlToBlob(urlData) {
    const bytes = window.atob(urlData.split(",")[1]); // 去掉url的头，并转换为byte
    // 处理异常,将ascii码小于0的转换为大于0
    const ab = new ArrayBuffer(bytes.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], { type: "image/png" });
  }
  return new Promise(resolve => {
    try {
      const image = new Image();
      image.src = URL.createObjectURL(file);
      image.onload = function() {
        // 默认按比例压缩
        let w = this.width;
        let h = this.height;
        let max = 1920; //最大尺寸，超过就压缩到1920
        let width = w; //计算后的允许的最大宽高
        let height = h;
        let defaultSize = 300 * 1024; //图片默认大小
        let quality = 0.5; // 图片质量
        if (w > h && w / h < 5) {
          //如果宽高比例不超过5的长图（长图压缩至1920可能会糊）
          if (w > max) {
            width = max;
            height = Math.floor((max / w) * h);
          }
        } else if (h > w && h / w < 5) {
          if (h > max) {
            height = max;
            width = Math.floor((max / h) * w);
          }
        }
        if (file.size < defaultSize) {
          quality = 0.75;
        }
        // 生成canvas
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d"); // 创建属性节点
        canvas.width = width;
        canvas.height = height;
        ctx.fillStyle = "#fff"; //背景置为白色 不然透明图片是黑底
        ctx.fillRect(0, 0, width, height);
        ctx.drawImage(this, 0, 0, width, height); //绘制图片
        const data = canvas.toDataURL("image/jpeg", quality);
        const blob = convertBase64UrlToBlob(data);
        let newFile = new File([blob], file.name, { type: file.type });
        resolve(newFile);
      };
    } catch (e) {
      resolve(file);
    }
  });
};

export const formatPhone = (str, type) => {
  /**
   *格式化手机号格式 13028888888 -> 130 2888 8888 || 130****8888 || 130 **** 8888
   *支持字符串检索与多项匹配
   *@param {String} str: 手机号码字符串
   *@param {Number} type: 格式化类型
   **/
  if (typeof str != "string") return str;
  let reg = /(1\d{10}|\*{7}\d{4}|1\d{2}\*{4}\d{4})/g;
  if (!reg.test(str)) return str;
  let matched = str.match(reg);
  for (let i = 0; i < matched.length; i++) {
    // 遍历并替换
    let rep = matched[i].split("");
    if (type == 3) {
      rep.splice(3, 4, "*", "*", "*", "*");
    } else {
      rep.splice(3, 0, " ");
      if (type == 2) {
        rep.splice(4, 4, "*", "*", "*", "*");
      }
      rep.splice(8, 0, " ");
    }
    rep = rep.join("");
    str = str.replace(matched[i], rep);
  }
  return str;
};

export const deepClone = (obj, map = new WeakMap()) => {
  /**
   *深拷贝对象(只考虑了普通的 object和 array两种数据类型)
   *@param {Object} obj 对象
   **/
  let type = getRawType(obj);
  if (type != "object" && type != "array") return obj;
  let clone = Array.isArray(obj) ? [] : {};
  if (map.get(obj)) {
    return obj;
  }
  map.set(obj, clone);
  for (let key in obj) {
    clone[key] = deepClone(obj[key], map);
  }
  return clone;
};

export const isNull = obj => {
  /**
   *判断对象是否为JSON
   *@param obj: 需要判断的对象
   **/
  return (typeof obj == "object" && !obj) || obj === "";
};

// 是否为'空'值
export const isEmpty = target => !(target || target === false || target === 0);

export const showSuccess = (message, callback) => {
  /**
   *提示成功信息
   *@String message 提示文字
   *@Function callback 提示框关闭后的回调
   **/
  Message({
    type: "success",
    message: message,
    showClose: true,
    duration: 1000,
    onClose() {
      callback && callback();
    }
  });
};

export const showError = (message, callback) => {
  /**
   *提示错误信息
   *@String message 提示文字
   *@Function callback 提示框关闭后的回调
   **/
  Message({
    type: "warning",
    message: message,
    showClose: true,
    duration: 3000,
    customClass: "message-hint",
    onClose() {
      callback && callback();
    }
  });
};

export const showInvalidMessage = (obj, prefix = "", suffix = "") => {
  /**
   *显示未通过表单验证的提示信息
   *@Object obj: form表单验证未通过验证的字段对象
   *@String prefix: 需要添加的前缀信息
   *@String suffix: 需要添加的后缀信息
   **/
  let arr = [];
  for (let key in obj) {
    arr.push(obj[key][0].message);
  }
  showError(`${prefix}${arr[0]}${suffix}`);
};

export const showConfirm = (
  resolve,
  message = "此操作将永久删除该项，是否继续？",
  reject
) => {
  /**
   *公用确认框
   *@String message: 提示信息
   *@Function resolve: 确认回调
   *@Function reject: 取消回调
   **/
  MessageBox.confirm(message, {
    type: "warning",
    dangerouslyUseHTMLString: true
  })
    .then(() => {
      resolve && resolve();
    })
    .catch(action => {
      reject && reject(action);
    });
};

export const hasClass = (el, className) => {
  /**
   *判断dom元素是否存在某个class
   *@Object el: dom元素元素
   *@String className: 判断的class名
   **/
  let reg = new RegExp("(\\s|^)" + className + "((\\s|$))");
  return el.className.match(reg);
};

export const addClass = (el, className) => {
  /**
   *给dom元素添加class
   *@Object el: dom元素元素
   *@String className: 添加的class名
   **/
  if (!hasClass(el, className)) {
    el.className += ` ${className}`;
  }
};

export const removeClass = (el, className) => {
  /**
   *移除dom元素的某个class
   *@Object el: dom元素元素
   *@String className: 移除的class名
   **/
  if (hasClass(el, className)) {
    let reg = new RegExp("(\\s|^)" + className + "((\\s|$))");
    el.className = el.className.replace(reg, "");
  }
};

export const handleLimit = (arr, max) => {
  /**
   *处理字符串，筛选边界值
   *@Array arr: 需要处理数组
   *@Number max: 处理的最大值，用作判断以上还是以下
   **/

  let result = [];
  let sort = [];
  let temp = [];
  arr.forEach(item => {
    let matched = item.match(/\d+/g);
    if (!Array.isArray(matched)) {
      return;
    }
    if (matched.length == 1) {
      sort.push(Number(matched[0]));
    }
    if (matched.length == 2) {
      result.push({
        min: Number(matched[0]),
        max: Number(matched[1])
      });
      temp.push(matched[0], matched[1]);
    }
  });
  sort.sort((a, b) => {
    return a - b;
  });
  temp.sort((a, b) => {
    return a - b;
  });
  if (sort.length == 1) {
    if (sort[0] >= temp[temp.length - 1] || sort[0] >= max) {
      result.push({
        min: Number(sort[0]),
        max: 100000000
      });
    } else {
      result.push({
        min: 0,
        max: Number(sort[0])
      });
    }
  }
  if (sort.length == 2) {
    result.push({
      min: 0,
      max: Number(sort[0])
    });
    result.push({
      min: Number(sort[1]),
      max: 10000000
    });
  }
  return result;
};

export const disabledFutureDate = {
  /*
   *el-date-picker组件禁用未来日期
   */

  disabledDate(date) {
    return date.getTime() >= Date.now();
  }
};

export const disabledPastDate = {
  /*
   *el-date-picker组件禁用过去日期
   */

  disabledDate(date) {
    return date.getTime() < Date.now();
  }
};

export const getSelectionText = () => {
  /*
   *获取页面选中的文本，一般用作表格选中文字时候不跳转的操作判断
   */
  if (window.getSelection) {
    return window.getSelection().toString();
  } else if (document.selection && document.selection.createRange) {
    return document.selection.createRange().text;
  }
  return "";
};

export const getCurrentDate = (format = "YYYY-MM-DD") => {
  /*
   *获取日期
   */

  //获取本日
  const toDay = moment().format(format);

  //获取本日开始和结束
  const dayStart = moment()
    .startOf("day")
    .format(format);
  const dayEnd = moment()
    .endOf("day")
    .format(format);

  //获取本周
  const weekStart = moment()
    .week(moment().week())
    .startOf("week")
    .format(format);
  const weekEnd = moment()
    .week(moment().week())
    .endOf("week")
    .format(format);

  //获取本月
  const monthStart = moment()
    .month(moment().month())
    .startOf("month")
    .format(format);
  const monthStartValue = moment()
    .month(moment().month())
    .startOf("month")
    .valueOf(); //时间戳
  const monthEnd = moment()
    .month(moment().month())
    .endOf("month")
    .format(format);
  const monthEndValue = moment()
    .month(moment().month())
    .endOf("month")
    .valueOf(); //时间戳

  //获取本年
  const yearStart = moment()
    .year(moment().year())
    .startOf("year")
    .format(format);
  const yearEnd = moment()
    .year(moment().year())
    .endOf("year")
    .format(format);

  return {
    day: {
      start: dayStart,
      end: dayEnd
    },
    year: { start: yearStart, end: yearEnd },
    month: {
      start: monthStart,
      end: monthEnd,
      startVal: monthStartValue,
      endVal: monthEndValue
    },
    week: { start: weekStart, end: weekEnd },
    today: toDay,
    yesterday: moment()
      .subtract(1, "days")
      .format(format), // 昨天
    yesterweek: {
      start: moment()
        .week(moment().week() - 1)
        .startOf("week")
        .format(format),
      end: moment()
        .week(moment().week() - 1)
        .endOf("week")
        .format(format)
    }, //上周
    yestermonth: {
      start: moment()
        .month(moment().month() - 1)
        .startOf("month")
        .format(format),
      end: moment()
        .month(moment().month() - 1)
        .endOf("month")
        .format(format)
    }, //上个月
    months3: {
      start: moment()
        .month(moment().month() - 2)
        .startOf("month")
        .format(format),
      end: moment()
        .month(moment().month())
        .endOf("month")
        .format(format)
    }, //最近3个月
    days7: {
      start: moment()
        .subtract(6, "days")
        .format(format),
      end: toDay
    }, // 最近七天
    days30: {
      start: moment()
        .subtract(29, "days")
        .format(format),
      end: toDay
    } // 最近30天
  };
};

export const findTreeParents = (
  tree,
  value,
  propsObj = { label: "label", value: "value", children: "children" }
) => {
  /**
   *根据value查询并返回祖先
   *@String|Number value: 值
   *@Array tree: 需要遍历查询的树
   *@Json propsObj: 参数
   **/
  let props = deepClone(propsObj);
  props.children = props.children || "children";
  let result = [];
  result.push(value);
  function find(tree, value, result) {
    let treeStr = typeof tree == "string" ? tree : JSON.stringify(tree);
    let reg = new RegExp(
      `${props.value}":([^"]+),[^\\}\\]\\[\\{]+\\[\\{[^\\[\\]]+${props.value}":${value}`
    );
    if (reg.test(treeStr)) {
      let parent = Number(treeStr.match(reg)[1]);
      result.push(parent);
      return find(treeStr, parent, result);
    } else {
      return result;
    }
  }
  find(tree, value, result);
  result = result.reverse();
  return result;
};

export const flatTree = (tree, children = "children") => {
  /**
   *扁平化json树
   *@Array tree: 需要遍历查询的树
   *@String children: 树子项的字段名
   **/
  if (!Array.isArray(tree)) return;
  const flat = tree => {
    return tree.reduce(
      (arr, item) => arr.concat([item], flat(item[children] || [])),
      []
    );
  };
  return flat(tree);
};

export const formatDate = (str, format = "yyyy-MM-dd HH:mm:ss") => {
  /**
   * @String str: 时间字符串
   * @String format: 时间格式 yyyy-MM-dd HH:mm:ss
   **/

  if (!str) {
    return;
  }
  const conver = num => {
    //补0
    return num < 10 ? `0${num}` : num;
  };
  const date = new Date(str); //需要判断的时间
  const isDate = !Date.parse(date); //传入的字符串或者时间戳是否为标准格式 ,如果不是返回：NaN or 0
  if (isDate) return;
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = conver(date.getHours());
  const min = conver(date.getMinutes());
  const sec = conver(date.getSeconds());
  const obj = { yyyy: year, MM: month, dd: day, HH: hour, mm: min, ss: sec };
  for (let key in obj) {
    format = format.replace(key, obj[key]);
  }
  return format;
};

export const formatNum = num => {
  /**
   * 格式化数字等，以千分号隔开
   * @String | Number : num
   **/
  if (typeof num === "object") {
    if (!num) {
      return "";
    }
  }
  if (isNaN(Number(num))) {
    return num;
  }
  let prefix = "";
  if (num < 0) {
    //为负数
    prefix = "-";
  }
  num = String(Math.abs(num)).split(".");
  let arr = num[0].split("").reverse();
  let res = [];
  for (var i = 0; i < arr.length; i++) {
    if (i % 3 == 0 && i != 0) {
      res.push(",");
    }
    res.push(arr[i]);
  }
  res.reverse();
  if (num[1]) {
    res = res.join("").concat("." + num[1]);
  } else {
    res = res.join("");
  }
  return `${prefix}${res}`;
};

/* istanbul ignore next */
export const on = (function() {
  if (document.addEventListener) {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.attachEvent("on" + event, handler);
      }
    };
  }
})();

/* istanbul ignore next */
export const off = (function() {
  if (document.removeEventListener) {
    return function(element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event) {
        element.detachEvent("on" + event, handler);
      }
    };
  }
})();

export const forObj = (obj1, obj2, addId = true) => {
  /**
   * 按照obj2的key把obj1的值筛选一遍
   * @String addId: 是否要加ID
   **/
  let query = {};
  for (let key in obj2) {
    query[key] = obj1[key];
  }
  if (addId) {
    query.id = obj1.id;
  }
  return JSON.parse(JSON.stringify(query));
};

export const own = (authActions, name) => {
  /**
   * 判断是否有权限
   * @String authActions: 权限数组
   * @String name: 权限标识字符串
   **/
  let arr = authActions || [];
  let flag = arr.includes(name);
  // 本地默认权限全开
  if (
    (location.hostname.includes("localhost") ||
      location.hostname.includes("10.150")) &&
    window.USE_LOCAL_MENUS
  ) {
    flag = true;
  }
  if (store.state.settings.userInfo.positionName === "超级管理员") {
    flag = true;
  }
  return flag;
};

export const zhToDate = zhTime => {
  /**
   * 年月日时间转成正常时间
   * xxxx年xx月xx日 => xxxx-xx-xx
   * @String zhTime: xxxx年xx月xx日
   **/
  let time = zhTime || "";
  if (time.includes("日")) {
    time = time.replace(/(年|月)/g, "-");
    time = time.replace("日", "");
  }
  return time;
};

export const toZhDate = date => {
  /**
   * xxxx-xx-xx => xxxx年xx月xx日
   * @String time:  xxxx-xx-xx
   **/
  date = String(date);
  let str = "";
  if (date) {
    str = date.slice(0, 4) + "年" + date.slice(4) + "月";
  }
  return str;
};

export const link = (arr, separator = "-") => {
  /**
   * 短线关联存在数据，例如：
   * 店组： 店 ; 店-组
   * @Array 需要处理的数据的数组集合
   **/
  if (!arr) return "";
  let str = "";
  arr = arr.filter(e => e);
  str = arr.join(separator);
  return str;
};

export const copyText = (text, isShowToast = true) => {
  /**
   * 复制文本
   * @param {String} text 需要复制的文本内容
   * @param {Boolean} isShowToast 是否显示提示
   **/
  // 数字没有 .length 不能执行selectText 需要转化成字符串
  let result = false;
  const textString = text.toString();
  let input = document.querySelector("#copy-input");
  if (!input) {
    input = document.createElement("textarea");
    input.id = "copy-input";
    input.readOnly = "readOnly"; // 防止ios聚焦触发键盘事件
    input.style.position = "absolute";
    input.style.left = "-1000px";
    input.style.zIndex = "-1000";
    document.body.appendChild(input);
  }

  input.value = textString;
  // ios必须先选中文字且不支持 input.select();
  selectText(input, 0, textString.length);
  if (document.execCommand("copy")) {
    document.execCommand("copy");
    result = true;
    isShowToast && Message.success("复制成功");
  }
  input.blur();
  // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
  // 选择文本。createTextRange(setSelectionRange)是input方法
  function selectText(textbox, startIndex, stopIndex) {
    if (textbox.createTextRange) {
      //ie
      const range = textbox.createTextRange();
      range.collapse(true);
      range.moveStart("character", startIndex); //起始光标
      range.moveEnd("character", stopIndex - startIndex); //结束光标
      range.select(); //不兼容苹果
    } else {
      //firefox/chrome
      textbox.setSelectionRange(startIndex, stopIndex);
      textbox.focus();
    }
  }
  return result;
};

export const imageWatermark = (target, urlField) => {
  /**
   * 图片添加水印
   * @param {String | Array<Object|String>} target 需要添加水印的图片地址或者地址数组
   * @param {String} urlField 如果target为数组对象时 里面图片地址的key名字
   **/
  if (!target) return target;
  // 用户名 用户编号
  const { realName, userCode } = store.state.settings.userInfo;
  // 生成图片水印地址
  const generateWatermark = (url = "") => {
    // oss 图片添加水印
    const watermark = `x-oss-process=image/watermark,text_${encodeURIComponent(
      Base64.encode(realName + userCode)
    )},color_ffffff,size_30,rotate_342,fill_1,t_38,x_150,y_150`;
    // 去掉图片后面跟的参数
    url = url.replace(/(\.(jpg|jpeg|gif|png|webp))(.*)+/, `$1`);
    return `${url}?${watermark}`;
  };
  // 如果传入的是一个字符串（url地址）
  if (typeof target === "string") {
    return generateWatermark(target);
    // 如果传入的是一个数组
  } else if (Array.isArray(target)) {
    return target.map(item => {
      if (!item) {
        return item;
        // 数组包含的是url地址
      } else if (typeof item === "string") {
        return generateWatermark(item);
      } else {
        // 数组包含的对象（默认认为除了字符串就是对象）
        return generateWatermark(item[urlField]);
      }
    });
  }
  return target;
};
export function getParentsByNodeId(nodeId, tree, nodeIdKey = "nodeId") {
  /**
   * @根据节点唯一key从树种找到该key的父级路劲
   * @param {String|Number} nodeId 当前key
   * @param {Array} tree 树
   * @param {String} nodeIdKey 树的唯一key的字段名
   **/
  const treeData = {};
  // 递归遍历树 处理每一项，并找到父级节点
  const loop = (tree, parent) => {
    for (let node of tree) {
      const newNode = {
        ...node,
        parent
      };
      treeData[node[nodeIdKey]] = newNode;
      if (node.children) {
        newNode.children = loop(node.children, newNode);
      }
    }
  };
  // 根据当前nodeId 和 treeData 递归找到父级id路径数组
  const getNodeParents = nodeId => {
    let node = [];
    const currentNode = treeData[nodeId];
    node.push(currentNode);
    if (currentNode.parent) {
      node = [...getNodeParents(currentNode.parent[nodeIdKey]), ...node];
    }
    return node;
  };
  loop(tree);
  return getNodeParents(nodeId);
}

export function debounce(fn, delay = 500) {
  /**
   * @函数防抖
   * @param {Function} fn 需要防抖的函数
   * @param {Number} delay 延时
   * **/
  let timeoutId;
  return function(...args) {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

export const format = {
  // 格式化字节 100b 100kb 100M
  byte(num) {
    if (num > 1000 && num < 1000 * 1000) {
      return keepDecimal(num / 1000) + "kb";
    } else if (num > 1000 * 1000) {
      return keepDecimal(num / 1000 / 1000) + "M";
    }
    return num + "b";
  },
  date(target, type = 0) {
    /**
     * 格式化时间
     * @param {String|Number} target: 时间字符串或者时间戳
     * @param {String|Number} type 格式字符串(如：YYYY-MM-DD HH:mm:ss) 或者 格式类型0 1 2 3...
     * **/
    if (target === null || target === undefined) return "";
    if (typeof target !== "string" && typeof target !== "number") return target;
    const d = moment(target);
    const oneMinute = 1000 * 60;
    const oneHour = oneMinute * 60;
    const oneDay = oneHour * 24;
    const nowValue = Date.now();
    const targetValue = d.valueOf();
    // 处理类型6
    const handle6 = d => {
      // 本年
      if (d.year() === moment().year()) {
        return d.format("MM月DD日");
      }
      return d.format("YYYY年MM月DD日");
    };
    // 处理类型7
    const handle7 = d => {
      // 本年
      if (d.year() === moment().year()) {
        return d.format("MM-DD HH:mm");
      }
      return d.format("YYYY-MM-DD HH:mm");
    };

    // 处理类型16
    const handle16 = d => {
      // 本年
      if (d.year() === moment().year()) {
        return d.format("MM/DD HH:mm");
      }
      return d.format("YYYY/MM/DD HH:mm");
    };
    // 处理类型10
    const handle10 = d => {
      // 1分钟内
      if ((nowValue - targetValue) / oneMinute < 1) {
        return "刚刚";
      }
      // 1小时内
      else if ((nowValue - targetValue) / oneMinute < 60) {
        return Math.floor((nowValue - targetValue) / oneMinute) + "分钟前";
      }
      // 1天以内
      else if ((nowValue - targetValue) / oneDay < 1) {
        return Math.floor((nowValue - targetValue) / oneHour) + "小时前";
      }
      // 10天内
      else if ((nowValue - targetValue) / oneDay < 10) {
        return Math.floor((nowValue - targetValue) / oneDay) + "天前";
      }
      return handle7(d);
    };

    // 处理类型17
    const handle17 = d => {
      // 1分钟内
      if ((nowValue - targetValue) / oneMinute < 1) {
        return "刚刚";
      }
      // 1小时内
      else if ((nowValue - targetValue) / oneMinute < 60) {
        return Math.floor((nowValue - targetValue) / oneMinute) + "分钟前";
      }
      // 1天以内
      else if ((nowValue - targetValue) / oneDay < 1) {
        return Math.floor((nowValue - targetValue) / oneHour) + "小时前";
      }
      return handle16(d);
    };
    // 处理类型13
    const handle13 = d => {
      // 今天
      if (d.isSame(moment(), "day")) {
        return d.format("HH:mm");
      }
      // 昨天
      if (d.isSame(moment().subtract(1, "day"), "day")) {
        return d.format("昨天 HH:mm");
      }
      // 本周
      if (d.isSame(moment(), "week")) {
        let week = d.day();
        switch (week) {
          case 1:
            return "星期一";
          case 2:
            return "星期二";
          case 3:
            return "星期三";
          case 4:
            return "星期四";
          case 5:
            return "星期五";
          case 6:
            return "星期六";
          case 0:
            return "星期日";
        }
      }
      // 本月
      if (d.isSame(moment(), "month")) {
        return d.format("MM月DD日 HH:mm");
      }
      return handle6(d);
    };
    if (typeof type === "string") {
      return d.format(type);
    }
    switch (type) {
      case 0:
        return d.format("YYYY-MM-DD");
      case 1:
        return d.format("YYYY-MM-DD HH:mm:ss");
      case 2:
        return d.format("YYYY年MM月DD日");
      case 3:
        return d.format("YYYY年MM月DD日 HH:mm:ss");
      case 4:
        return d.format("MM月DD日 HH:mm");
      case 5:
        return d.format("MM月DD日");
      case 6:
        return handle6(d);
      case 7:
        return handle7(d);
      case 8:
        return d.format("YYYY年MM月DD日 HH:mm");
      case 9:
        return d.format("YYYY-MM-DD HH:mm");
      case 10:
        return handle10(d);
      case 11:
        return d.format("MM-DD");
      case 12:
        return d.format("MM-DD HH:mm");
      case 13:
        return handle13(d);
      case 14:
        return d.format("YYYY-MM-DD HH:mm");
      case 15:
        return d.format("YYYY/MM/DD HH:mm");
      case 16:
        return handle16(d);
      case 17:
        return handle17(d);
    }
    return target;
  }
};

// 生成UUID
export const generateUUID = () => {
  const chars = "0123456789abcdef";

  const parts = [];

  // 生成第一个部分
  for (let i = 0; i < 8; i++) {
    const index = Math.floor(Math.random() * 16);
    parts.push(chars[index]);
  }

  // 生成第二个部分
  for (let i = 0; i < 4; i++) {
    const index = Math.floor(Math.random() * 16);
    parts.push(chars[index]);
  }

  // 生成第三个部分
  parts.push("4");

  // 生成第四个部分
  const randomDigit = ["8", "9", "a", "b"][Math.floor(Math.random() * 4)];
  parts.push(randomDigit);

  // 生成第五个部分
  for (let i = 0; i < 12; i++) {
    const index = Math.floor(Math.random() * 16);
    parts.push(chars[index]);
  }

  // 连接所有部分并返回完整的 UUID
  return parts.join("");
};
// 阻塞
export const sleep = (duration = 500) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(true);
    }, duration);
  });
};

export const toW = (num, unit = "", defUnit = "") => {
  /*
   *以万为单位 最多保留两位小数
   */
  if (isNaN(Number(num)) || Number(num) < 10000) return num + defUnit;
  const res = keepDecimal(division(Number(num), 10000));
  return res + unit;
};

/**
 * @description 要将路径字符串（如 /work/house/old）转换为帕斯卡命名法（PascalCase，如 WorkHouseOld）
 * @param {path} String
 */
export const pathToPascalCase = path => {
  console.log(path);
  // 移除开头的斜杠，按斜杠分割路径
  if (typeof path !== "string") return "";
  const segments = path.replace(/^\//, "").split("/");

  // 将每个片段的首字母大写，其余小写，然后拼接
  return segments
    .map(
      segment =>
        segment.charAt(0)?.toUpperCase() + segment.slice(1)?.toLowerCase()
    )
    .join("");
};
